export const GET_COMMENT = "GET_COMMENT";
export const GET_COMMENT_BY_NEWS_ID = "GET_COMMENT_BY_NEWS_ID";
export const COMMENT_ERROR = "COMMENT_ERROR";
export const POST_COMMENT = "POST_COMMENT";
